/* Farm Heaven — Global theme JS. Small helpers used across sections. */
(function () {
  document.documentElement.classList.remove('no-js');

  /* --------------------------------------------------
     Meta Pixel — top-level events so Meta Pixel Helper
     detects them. We block the form's navigation, fire
     the pixel + wait for the beacon, then submit.
     -------------------------------------------------- */
  var FH_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SAR';
  var FH_PIXEL_HOLD_MS = 350; // give the beacon time to fire before nav

  function fbqTrack(event, params) {
    if (typeof window.fbq === 'function') {
      try { window.fbq('track', event, params); }
      catch (e) { console.warn('[FH-Pixel] track failed', e); }
    }
  }

  // Prevent a form's submit, run cb, then submit natively after the pixel fires.
  function fireThenSubmit(form, submitter) {
    form.__fhFired = true;
    setTimeout(function () {
      // Recreate the click on the original submit button so name=checkout etc. survives
      if (submitter && submitter.disabled === false) {
        var clone = submitter.cloneNode(true);
        clone.style.display = 'none';
        form.appendChild(clone);
        clone.click();
      } else {
        form.submit();
      }
    }, FH_PIXEL_HOLD_MS);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.__fhFired) return; // avoid re-entering after we resubmit
    var action = (form.getAttribute('action') || '').toLowerCase();

    // ---- AddToCart ----
    if (action.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      var variantInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var variantId = variantInput ? variantInput.value : null;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      var priceMajor = 0;
      var title = document.title || '';
      if (variantId) {
        var row = document.querySelector('[data-bb-variant][data-variant-id="' + variantId + '"]');
        if (row) {
          var priceEl = row.querySelector('[data-var-price] bdi');
          if (priceEl) priceMajor = parseFloat((priceEl.textContent || '').replace(/[^0-9.]/g, '')) || 0;
        }
        var titleEl = document.querySelector('.bb__title, h1');
        if (titleEl) title = titleEl.textContent.trim();
      }

      fbqTrack('AddToCart', {
        content_type: 'product',
        content_ids: variantId ? [String(variantId)] : [],
        content_name: title,
        value: priceMajor * qty,
        currency: FH_CURRENCY,
        contents: variantId ? [{ id: String(variantId), quantity: qty, item_price: priceMajor }] : []
      });

      fireThenSubmit(form, e.submitter);
      return;
    }

    // ---- InitiateCheckout — fired from the cart page's checkout button ----
    if (action.indexOf('/cart') !== -1 && e.submitter && (e.submitter.name === 'checkout' || /checkout/i.test(e.submitter.className))) {
      e.preventDefault();

      // Read the cart totals directly from the summary the theme already renders
      var summary = document.querySelector('[data-fh-summary]');
      var subtotalEl = summary && summary.querySelector('[data-fh-subtotal] bdi');
      var totalEl    = summary && summary.querySelector('[data-fh-total] bdi');
      var countEl    = summary && summary.querySelector('[data-fh-count]');
      var subtotal = subtotalEl ? parseFloat((subtotalEl.textContent || '').replace(/[^0-9.]/g, '')) : 0;
      var total    = totalEl    ? parseFloat((totalEl.textContent    || '').replace(/[^0-9.]/g, '')) : subtotal;
      var count    = countEl    ? (parseInt(countEl.textContent, 10) || 1) : 1;

      // Build contents from the visible cart rows
      var contents = [];
      var ids = [];
      document.querySelectorAll('[data-line-key]').forEach(function (row) {
        var vid = row.getAttribute('data-variant-id') || '';
        var qtyInput = row.querySelector('[data-qty-input]');
        var q = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var priceRaw = row.getAttribute('data-unit-price'); // cents
        var itemPrice = priceRaw ? Number(priceRaw) / 100 : 0;
        if (vid) {
          contents.push({ id: String(vid), quantity: q, item_price: itemPrice });
          ids.push(String(vid));
        }
      });

      fbqTrack('InitiateCheckout', {
        content_ids: ids,
        contents: contents,
        num_items: count,
        value: total || subtotal,
        currency: FH_CURRENCY
      });

      fireThenSubmit(form, e.submitter);
      return;
    }
  }, true);

  // Global accordion delegation
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-acc-q]');
    if (!btn) return;
    var item = btn.closest('[data-acc-item]');
    if (!item) return;
    var isOpen = item.classList.contains('is-open');
    var scope = btn.closest('[data-acc]');
    if (scope && !scope.hasAttribute('data-acc-multi')) {
      scope.querySelectorAll('[data-acc-item].is-open').forEach(function (el) {
        if (el !== item) el.classList.remove('is-open');
      });
    }
    item.classList.toggle('is-open', !isOpen);
    btn.setAttribute('aria-expanded', String(!isOpen));
  });

  // Marquee sizing helper — sections opt in with data-marquee-track
  function fitMarquees() {
    document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
      var group = track.querySelector('[data-marquee-group]');
      if (!group) return;
      var viewport = track.parentElement;
      if (!viewport) return;
      // Reset animation to remeasure
      track.style.animation = 'none';
      // Force reflow
      /* eslint-disable-next-line no-unused-expressions */
      track.offsetWidth;
      track.style.animation = '';
      var safety = 0;
      while (track.scrollWidth - group.offsetWidth < viewport.offsetWidth && safety < 12) {
        track.appendChild(group.cloneNode(true));
        safety++;
      }
      track.style.setProperty('--marquee-shift', group.offsetWidth + 'px');
    });
  }
  window.addEventListener('load', fitMarquees);
  window.addEventListener('resize', fitMarquees);
  document.addEventListener('shopify:section:load', fitMarquees);

  // Cart count updater — sections may dispatch a 'fh:cart:update' event
  document.addEventListener('fh:cart:update', function (e) {
    var count = (e.detail && typeof e.detail.count === 'number') ? e.detail.count : null;
    if (count === null) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  });
})();
